import initialState from './initialState';
import {
  ADD_NEW_SELF_LAUNCH,
  ADD_NEW_SELF_LAUNCH_DONE,
  ADD_NEW_SELF_LAUNCH_ERROR,
  ADD_NEW_SELF_LAUNCH_LOADING,
  ADD_NEW_SELF_LAUNCH_SUCCESS,
  FETCH_SELF_LAUNCH_LIST,
  FETCH_SELF_LAUNCH_LIST_DONE,
  FETCH_SELF_LAUNCH_LIST_ERROR,
  FETCH_SELF_LAUNCH_LIST_LOADING,
  FETCH_SELF_LAUNCH_LIST_SUCCESS,
  REMOVE_SELF_LAUNCH,
  REMOVE_SELF_LAUNCH_DONE,
  REMOVE_SELF_LAUNCH_ERROR,
  REMOVE_SELF_LAUNCH_LOADING,
  REMOVE_SELF_LAUNCH_SUCCESS
} from '../actions/actionTypes';

// handles Configuration defaults related actions

const reducerSelfLaunch = (state, action) => {
  switch (action.type) {
    case FETCH_SELF_LAUNCH_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SELF_LAUNCH_LIST_SUCCESS:
      return {
        ...state,
        heroes: action.heroes,
        error: null
      };
    case FETCH_SELF_LAUNCH_LIST_ERROR:
      return {
        ...state,
        heroes: null,
        error: action.error
      };
    case FETCH_SELF_LAUNCH_LIST_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const reducerAddNewSelfLaunch = (state, action) => {
  switch (action.type) {
    case ADD_NEW_SELF_LAUNCH_LOADING:
      return {
        ...state,
        addLoading: true,
        addErrors: null,
        addError: null
      };
    case ADD_NEW_SELF_LAUNCH_SUCCESS:
      return {
        ...state,
        heroes: action.heroes.all_users,
        addErrors: action.heroes.errors,
        addError: null
      };
    case ADD_NEW_SELF_LAUNCH_ERROR:
      return {
        ...state,
        addErrors: null,
        addError: action.error
      };
    case ADD_NEW_SELF_LAUNCH_DONE:
      return {
        ...state,
        addLoading: false
      };
    default:
      return state;
  }
};

const reducerRemoveSelfLaunch = (state, action) => {
  switch (action.type) {
    case REMOVE_SELF_LAUNCH_LOADING:
      return {
        ...state,
        removeLoading: true,
        removeError: null
      };
    case REMOVE_SELF_LAUNCH_SUCCESS:
      return {
        ...state,
        heroes: action.heroes,
        removeError: null
      };
    case REMOVE_SELF_LAUNCH_ERROR:
      return {
        ...state,
        removeError: action.error
      };
    case REMOVE_SELF_LAUNCH_DONE:
      return {
        ...state,
        removeLoading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(FETCH_SELF_LAUNCH_LIST)) {
    return reducerSelfLaunch(state, action);
  } else if (action.type.startsWith(ADD_NEW_SELF_LAUNCH)) {
    return reducerAddNewSelfLaunch(state, action);
  } else if (action.type.startsWith(REMOVE_SELF_LAUNCH)) {
    return reducerRemoveSelfLaunch(state, action);
  } else {
    return state;
  }
};
